import ReactDOM from 'react-dom/client';
import {BrowserRouter} from 'react-router-dom';
import {App} from './app';

// import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>,
);

/*
  If you want to start measuring performance in your app, pass a function
  to log results (for example: reportWebVitals(console.log))
  or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
  reportWebVitals();
 */

/*
  "React.StrictMode" was disabled by the next reasons:
   - double re-rendering of components
   - issue with ant-design library: https://github.com/ant-design/ant-design/issues/26136
*/
